import React, {useState} from 'react';

import {Button, Input, Modal} from '@mantine/core';
import {useCurrentUser} from '../../hooks/useCurrentUser';
import {useModule} from '@/hooks/useModule';

type Props = {
    data?: {
    };
    close: () => void;
};

export const EditProfileModal = (props: Props) => {
    return (
        <Modal
            title={'Edit Profile'}
            opened={Boolean(props.data)}
            onClose={props.close}
            closeOnClickOutside={false}
            withCloseButton={true}
        >
            {props.data && (
                <EditProfileModalForm
                    data={props.data}
                    close={props.close}
                />
            )}
        </Modal>
    );
}

type EditProfileModalFormProps = {
    data: {
    };
    close: () => void;
}

const EditProfileModalForm = (props: EditProfileModalFormProps) => {
    const currentUser = useCurrentUser()!;

    const [username, setUsername] = useState(currentUser.name);

    const userModule = useModule('User');

    const handleSubmit = async () => {
        const trimmedUsername = username.trim();
        if (trimmedUsername && trimmedUsername !== currentUser.name) {
            await userModule.updateProfile({username: trimmedUsername});
        }

        props.close();
    };

    return (
        <div>
            <div style={{margin: '10px'}}>
                <p>
                    Nickname
                </p>
                <Input
                    size='sm'
                    w={200}
                    onChange={e => setUsername(e.target.value)}
                    value={username}
                    autoCapitalize='off'
                    autoComplete='off'
                    autoCorrect='off'
                    spellCheck={false}
                    // pattern="[a-z][a-z0-9]+"
                />
            </div>

            <div style={{margin: '10px'}}>
                <Button
                    size='xs'
                    disabled={!username}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
                <Button
                    size='xs'
                    style={{marginLeft: '10px'}}
                    onClick={props.close}
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
};
